var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusIncompleteData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF7900",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 11.1667V10.1485C5.33333 8.77091 5.33333 8.08212 5.46817 7.51334C5.90424 5.67384 7.3405 4.23758 9.18 3.80151C9.74879 3.66667 10.4376 3.66667 11.8151 3.66667V3.66667C12.4185 3.66667 12.7202 3.66667 13.0095 3.7005C13.9302 3.80813 14.8029 4.1696 15.53 4.74451C15.7585 4.92517 15.9718 5.1385 16.3985 5.56515L16.5833 5.75C17.1919 6.35861 17.4962 6.66291 17.7377 7.00148C18.1784 7.61952 18.4726 8.3298 18.598 9.07846C18.6667 9.48858 18.6667 9.91892 18.6667 10.7796V11.1667M18.6667 14.5V14.9167V15.75C18.6667 18.2813 16.6146 20.3333 14.0833 20.3333V20.3333H13.6667M5.33333 14.5V14.9167V15.75C5.33333 18.2813 7.38536 20.3333 9.91667 20.3333V20.3333H10.3333M13.6667 4.08334V5.4667C13.6667 6.5868 13.6667 7.14685 13.8847 7.57468C14.0764 7.951 14.3824 8.25696 14.7587 8.44871C15.1865 8.6667 15.7466 8.6667 16.8667 8.6667H18.25",
    stroke: "#FF7900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIncompleteData);
export default __webpack_public_path__ + "static/media/status-incomplete-data.8e0c5178e0697c0f9745d79ed5dae815.svg";
export { ForwardRef as ReactComponent };